import React from "react";

interface ISectionTitleComponentProps {
    title: string;
    subTitle: string;
}

export const SectionTitleComponent: React.FC<ISectionTitleComponentProps> = (
    props: ISectionTitleComponentProps
) => {
    const { title, subTitle } = props;

    return (
        <div className="container section-title" data-aos="fade-up">
            <h2>{title}</h2>
            <p>{subTitle}</p>
        </div>
    );
};
